import React, { useEffect, useState } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { getBankAccountAll } from "../../MasterData/_redux/bank-account/bankAccountCrud";
import { getBankAll } from "../../MasterData/_redux/bank/bankCrud";

// Validation schema
const ImportDonaturEditSchema = Yup.object().shape({
  name: Yup.string()
    .min(3, "Minimum 3 symbols")
    .max(50, "Maximum 50 symbols")
    .required("Name wajb diisi"),
});

export function ImportDonaturForm({
  saveImportDonatur,
  importMutationImportDonatur,
  previewFile,
  setSpreadSheet

}) {
  useEffect(() => {
    getOptions();
  }, []);

  const [options, setOptions] = useState({
    bank: [],
    no_rek: [],
  });

  const getOptions = () => {
    getBankAll()
      .then((res) =>
        setOptions((prevState) => ({
          ...prevState,
          bank: res.data.data,
        }))
      )
      .catch((err) => console.log(err));
    getBankAccountAll()
      .then((res) =>
        setOptions((prevState) => ({
          ...prevState,
          no_rek: res.data.data,
        }))
      )
      .catch((err) => console.log(err));
  };

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={importMutationImportDonatur}
        validationSchema={ImportDonaturEditSchema}
        onSubmit={(values) => saveImportDonatur(values)}
      >
        {({ handleSubmit, setFieldValue, values }) => (
          <>
            <Form className="form form-label-right">
              <div className="form-group row">
                <div className="col-lg-2">
                  <label>File Donatur</label>
                </div>
                <div className="col-lg-4">
                  <input
                    type="file"
                    name="name"
                    placeholder="Text"
                    label="Name"
                    accept=".xlsx"
                    // onChange={(e) => previewFile(e)}
                    onChange={(e) => setSpreadSheet(e.target.files[0])}
                  />
                </div>
              </div>
            </Form>
          </>
        )}
      </Formik>
    </>
  );
}
